export const VIEW = {
  REGULAR: 'regular',
  ACCENT: 'accent',
  LINK: 'link',
}
